import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { paymentVerify } from '../../redux/payment/actions';
import Loader from '../../components/loader/Loader';

export default function PaymentVerifyfulPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userPaymentDetails = useSelector((state) => state.payment.userPaymentDetails);
  const paymentStatus = useSelector((state) => state.payment.paymentStatus);
  const slug = localStorage.getItem('slug');

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const paymentIntentId = query.get('payment_intent');
    if (paymentIntentId) {
      dispatch(paymentVerify(userPaymentDetails?.payment_history_item?.id));
    }
  }, []);

  useEffect(() => {
    navigate(`/pay/${slug}`);
  }, [paymentStatus]);

  return (
    <div className="main_section h-full bg_icon bg-mobile-view">
      <div className="container px-only-md-2 box-alignment">
        <Loader />
      </div>
    </div>
  );
}
